module.exports = __webpack_public_path__ + "img/img005.743d19cc.png";